
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import img_404 from '../../assets/images/img_404.svg';
import { PRODUCT_NAME } from '../../constants/global';

import { FullImage } from '../../components/customStyles/custom';

const Error = () => {

  return (
    <Stack
      variant="center-center"
      sx={{
        flexDirection: 'column',
        height: 'calc(100vh - 40px - 64px - 100px)'
      }}
    >
      <FullImage src={img_404} alt="404 error" />

      <Typography
        align="center"
        sx={{
          marginTop: '3rem',
          marginBottom: '2.5rem'
        }}
      >
        您查詢的頁面不存在，可能已經移除或暫時無法使用。
      </Typography>
      <Link to='/'>
        <Button variant="contained">回 {PRODUCT_NAME} 首頁</Button>
      </Link>
    </Stack>
  );
}


export default Error;